export default __webpack_public_path__ + "static/media/rhea3.5acbb8b1.png";